import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { LANG } from "../../constants/language";
import StepFirst from "./register-steps/stepFirst";
import StepSecond from "./register-steps/stepSecond";
import ThankYou from "./register-steps/thankYou";
import { DEVICE_TYPE, emailRegex, nameRegex, phoneUSDigitsOnly, PHONE_COUNTRY_CODE } from "../../constants/utlis";
import { registerUser, resendOTP, verifyOTP } from "../../services/auth.service";


const stepFirstInitialValues = {
  name: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  device_type: DEVICE_TYPE,
  termsConditions: false,
}

const stepSecondInitialValues = {
  otp: ""
}

const stepFirstRegisterSchema = Yup.object().shape({
  // name: Yup.string().matches(nameRegex, 'The name can only include letters, spaces, hyphens, or apostrophes.').required("Name is required"),
  name: Yup.string().required("Name is required").matches(nameRegex, "Name can only contain letters, spaces, hyphens, apostrophes, and periods"),
  // email: Yup.string().email(LANG.PLEASE_ADD_VALID_EMAIL).required("Email is required"),
  email: Yup.string().required(LANG.EMAIL_IS_REQUIRED).matches(emailRegex, LANG.PLEASE_ADD_VALID_EMAIL),
  // phone: Yup.string().min(10, LANG.MINIMUM_LIMIT_PHONE_CHAR).max(12, LANG.MAXIMUM_LIMIT_PHONE_CHAR).matches(phoneRegExp, 'Phone number is not valid').required("Phone number is required"),
  phone: Yup.string().matches(phoneUSDigitsOnly, "Phone number must be 9–10 digits").required("Phone number is required"),
  password: Yup.string().required(LANG.PASSWORD_IS_REQUIRED).min(8, LANG.PASSWORD_MIN_LENGTH).matches(/[A-Z]/, LANG.PASSWORD_UPPERCASE).matches(/[a-z]/, LANG.PASSWORD_LOWERCASE).matches(/[0-9]/, LANG.PASSWORD_NUMBER).matches(/[@#%!-]/, LANG.PASSWORD_SYMBOL),
  confirmPassword: Yup.string().required("Confirm password is required").oneOf([Yup.ref("password")], "Passwords must match"),
  device_type: Yup.string(),
  termsConditions: Yup.boolean(),
});

const stepSecondRegisterSchema = Yup.object().shape({
});


const Register = () => {
  const navigate = useNavigate();
  const route = all_routes;
  const [error, setError] = useState<any>(null);
  const [step, setStep] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(60); // Start countdown from 60 seconds
  const [user, setuser] = useState<any>(null);


  useEffect(() => {
  }, [setStep])

  const stepOneFormik = useFormik({
    initialValues: stepFirstInitialValues,
    validationSchema: stepFirstRegisterSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        const fullPhone = `${PHONE_COUNTRY_CODE}${values.phone}`;
        let payload = {
          name: values.name,
          email: values.email,
          phone: fullPhone,
          password: values.password,
          device_type: values.device_type,
        }

        const result = await registerUser(payload);
        localStorage.setItem('phone', result.data?.data?.phone);
        localStorage.setItem('uuid', result.data?.data?.uuid);

        toast.success(result.data.message || "Account Created Successfully!");
        setLoading(false);
        setStep(2);
      } catch (error: any) {
        toast.error(error.response?.data?.error || "Something went wrong");
        console.log(error, loading)
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  const stepSecondFormik = useFormik({
    initialValues: stepSecondInitialValues,
    validationSchema: stepSecondRegisterSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const otpValue = otp.join(""); // combine 6 digits
      const uuid = localStorage.getItem("uuid");

      if (!uuid) {
        toast.error("User Id not found. Please login again.");
        return;
      }

      if (otpValue.length !== 6) {
        toast.error("Please enter a 6-digit OTP");
        return;
      }

      setLoading(true);
      try {
        const result = await verifyOTP({ user_uuid: uuid, otp: otpValue });

        toast.success(result.data.message || "OTP Verified Successfully!");

        setuser(result.data)

        setError(null)
        setLoading(false);
        setStep(3);
        setOtp(["", "", "", "", "", ""]);
      } catch (error: any) {
        toast.error(error.response?.data?.error || "OTP verification failed");
        console.log(error, loading)
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  // check if all OTP boxes are filled
  const isOtpComplete = otp.every((digit) => digit !== "");

  // Handle resend OTP
  const handleResendOTP = async () => {
    if (countdown > 0) return;
    const uuid = localStorage.getItem("uuid");

    if (!uuid) {
      toast.error("User Id not found. Please login again.");
      return;
    }

    try {
      setLoading(true);
      const result = await resendOTP({ user_uuid: uuid });
      toast.success(result.data.message || "OTP resent successfully!");
      setCountdown(60); // Reset countdown after resend
      setLoading(false);
      setOtp(["", "", "", "", "", ""]);
    } catch (error: any) {
      toast.error(error.response?.data?.error || "Failed to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  // Countdown effect
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null; // Initialize timer as null
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer); // Only clear if timer is defined
    };
  }, [countdown]);

  // // Initialize countdown when component mounts
  // useEffect(() => {
  //   setCountdown(60); // Start countdown on mount
  // }, []);


  const renderLayout = (activeStep: number) => {

    switch (activeStep) {
      case 1: {
        return <StepFirst formik={stepOneFormik} />;
      }
      case 2: {
        return <StepSecond formik={stepSecondFormik} otp={otp} setOtp={setOtp} isOtpComplete={isOtpComplete} error={error} handleResendOTP={handleResendOTP} loading={loading} countdown={countdown} setCountdown={setCountdown} />;
      }
      case 3: {
        return <ThankYou email={otp} user={user} />;
      }
    }
  }

  return (
    <div>
      <>
        {renderLayout(step)}
      </>
    </div>
  );
};

export default Register;
